/* eslint-disable indent */
import { Grid, makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import i18n from 'i18n';
import { DashboardProps } from 'modules/advisors/interfaces';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { formatCurrency } from 'utils/helpers';
import { inAdminView, inOperatorView, inSuperAdminView } from 'utils/role';
import GenericCard from './GenericCard';
import styles from './styles';

const useStyles = makeStyles(styles);

interface SavingsCardProps {
  dashboard: DashboardProps | null;
  companySelected: CompanyData | null;
  role?: RolesEnum;
}

const SavingsCard = ({
  dashboard,
  companySelected,
  role,
}: SavingsCardProps) => {
  const classes = useStyles();
  const savingsClassName = clsx(classes.savings, {
    [classes.savingsSuperAdmin]: inSuperAdminView(role, companySelected),
    [classes.savingsAdmin]: inAdminView(role, companySelected),
    [classes.savingsOperator]: inOperatorView(role, companySelected),
    [classes.savingsCompanyContext]: companySelected,
  });

  return (
    <GenericCard
      title={i18n.t('ADVISOR_PAGE.ESTIMATED_SAVINGS_FROM_SUGGESTED_KEY')}
      content={
        <Grid>
          <Grid
            container
            alignItems="flex-end"
            className={classes.monthlySavings}
          >
            <Typography className={savingsClassName}>
              {formatCurrency(
                dashboard?.pending_advisors_monthly_estimated_cost_savings
              )}
            </Typography>
            <Typography className={classes.monthlyText}>{`/${i18n.t(
              'MONTH_KEY'
            )}`}</Typography>
          </Grid>
        </Grid>
      }
      footer={
        <Typography className={classes.annualSavings}>{`${i18n.t(
          'ANNUAL_KEY'
        )}: ${formatCurrency(
          dashboard?.pending_advisors_annual_estimated_cost_savings
        )}`}</Typography>
      }
    />
  );
};

const mapStateToProps = ({
  advisors: { dashboard },
  authenticate: { data, companySelected },
}: ApplicationState) => ({
  dashboard,
  companySelected,
  role: data?.role,
});

export default connect(mapStateToProps, {})(SavingsCard);
